import React from 'react';
import logo from './logo.svg';
import './App.css';
import 'bootstrap/dist/css/bootstrap.css';
import Hiring from './Hiring.js';
import * as page from './enum.js';

class Matlab extends React.Component{

    constructor(props){
       super(props);
       this.state = {
            flag : page.Pages.Home,
            Modal_Check : "Overview",
            Modal_title : "Title",
       }
    }

    Module = () => {
        console.log("Hello");
        var Ov = document.querySelector('#Bottom_Border_line');
        var Mod = document.querySelector('#Bottom_Border_line1');
        var Fee = document.querySelector('#Bottom_Border_line2');
        var Con = document.querySelector('#Bottom_Border_line3');
        var Ben = document.querySelector('#Bottom_Border_line4');
        Mod.style.borderBottom = "2px solid";
        Fee.style.borderBottom = "none";
        Con.style.borderBottom = "none";
        Ben.style.borderBottom = "none";
        Ov.style.borderBottom = "none";
        this.setState({
                    ...this.state,
                    Modal_Check : "Module",
        });
    }

    Overview = () => {
        console.log("Hello");
        var Ov = document.querySelector('#Bottom_Border_line');
        var Mod = document.querySelector('#Bottom_Border_line1');
        var Fee = document.querySelector('#Bottom_Border_line2');
        var Con = document.querySelector('#Bottom_Border_line3');
        var Ben = document.querySelector('#Bottom_Border_line4');
        Mod.style.borderBottom = "none";
        Fee.style.borderBottom = "none";
        Con.style.borderBottom = "none";
        Ben.style.borderBottom = "none";
        Ov.style.borderBottom = "2px solid";
        this.setState({
                    ...this.state,
                    Modal_Check : "Overview",
        });
    }

    Fee = () => {
        console.log("Hello");
        var Ov = document.querySelector('#Bottom_Border_line');
        var Mod = document.querySelector('#Bottom_Border_line1');
        var Fee = document.querySelector('#Bottom_Border_line2');
        var Con = document.querySelector('#Bottom_Border_line3');
        var Ben = document.querySelector('#Bottom_Border_line4');
        Mod.style.borderBottom = "none";
        Fee.style.borderBottom = "2px solid";
        Con.style.borderBottom = "none";
        Ben.style.borderBottom = "none";
        Ov.style.borderBottom = "none";
        this.setState({
                    ...this.state,
                    Modal_Check : "Fee",
        });
    }

    Contact = () => {
        console.log("Hello");
        var Ov = document.querySelector('#Bottom_Border_line');
        var Mod = document.querySelector('#Bottom_Border_line1');
        var Fee = document.querySelector('#Bottom_Border_line2');
        var Con = document.querySelector('#Bottom_Border_line3');
        var Ben = document.querySelector('#Bottom_Border_line4');
        Mod.style.borderBottom = "none";
        Fee.style.borderBottom = "none";
        Con.style.borderBottom = "2px solid";
        Ben.style.borderBottom = "none";
        Ov.style.borderBottom = "none";
        this.setState({
                    ...this.state,
                    Modal_Check : "Contact",
        });
    }

    Benefits = () => {
        var Ov = document.querySelector('#Bottom_Border_line');
        var Mod = document.querySelector('#Bottom_Border_line1');
        var Fee = document.querySelector('#Bottom_Border_line2');
        var Con = document.querySelector('#Bottom_Border_line3');
        var Ben = document.querySelector('#Bottom_Border_line4');
        Mod.style.borderBottom = "none";
        Fee.style.borderBottom = "none";
        Con.style.borderBottom = "none";
        Ben.style.borderBottom = "2px solid";
        Ov.style.borderBottom = "none";
        this.setState({
                    ...this.state,
                    Modal_Check : "Benefits",
        });
    }

    Check = () => {
        var ch = this.state.Modal_Check;
        if(ch === "Overview"){
            return (
                <div>
                    <h4 class="mt-2">About Matlab Training-</h4>
                    <p>ScimoX provides the best industry-relevant content with systematic delivery on the most popular algorithm MATLAB.
                    MATLAB is a high-performance language for technical computing. It integrates computation, visualization, and
                    programming in an easy-to-use environment where problems and solutions are expressed in familiar mathematical notation.</p>
                    <h4 class="mt-2">The learning objectives of MATAB course in ScimoX-</h4>
                    <div>The learning objectives of Django course in ScimoX:</div>
                    <div class="mt-1">1. Internalize the concepts & constructs of MATLAB.</div>
                    <div class="mt-1">2. Learn to create your own Websites.</div>
                    <div class="mt-1">3. Master In Algorithm development.</div>
                    <div class="mt-1">4. Master in Modeling, simulation, and prototyping.</div>
                    <div class="mt-1">5. How to useData analysis, exploration, and visualization.</div>
                    <div class="mt-1">7. Create Graphical User Interface buildings.</div>
                    <div class="mt-1">8. 100% Interview Guarantee.</div>
                </div>
            )
        }else if(ch === "Module"){
            return (
                <div id="Scroll_Me">
                    <h4 class="mt-3">MATLAB Course Syllabus-</h4>
                    <div class="mt-3">1. Introduction to Matlab:</div>
                    <div>STARTING MATLAB, MATLAB WINDOWS,WORKING IN THE COMMAND WINDOW,ARITHMETIC OPERATIONS WITH SCALARS DISPLAY FORMATS,
                     ELEMENTARY MATH BUILT-IN FUNCTIONS ,DEFINING SCALAR VARIABLES, COMMANDS FOR MANAGING ,VARIABLES , SCRIPT FILES ,
                     EXAMPLES OF MATLAB APPLICATIONS.</div>
                    <div class="mt-2">2. Arrays:</div>
                    <div>CREATING A ONE-DIMENSIONAL ARRAY ,CREATING A TWO-DIMENSIONAL ARRAY ,NOTES ABOUT VARIABLES IN MATLAB ,THE TRANSPOSE OPERATOR ,
                    ARRAY ADDRESSING ,USING A COLON : IN ADDRESSING ARRAYS ,ADDING ELEMENTS TO EXISTING VARIABLES ,DELETING ELEMENTS ,BUILT-IN
                    FUNCTIONS FOR HANDLING ARRAYS ,STRINGS AND STRINGS AS VARIABLES.</div>
                    <div class="mt-2">3. Mathematical Operations with Arrays:</div>
                    <div>ADDITION AND SUBTRACTION , ARRAY MULTIPLICATION , ARRAY DIVISION , ELEMENT-BY-ELEMENT OPERATIONS , USING ARRAYS
                     IN MATLAB BUILT-IN MATH FUNCTIONS , BUILT-IN FUNCTIONS FOR ANALYIS.</div>
                    <div class="mt-2">4. Using Script Files and Managing Data:</div>
                    <div>THE MATLAB WORKSPACE ,INPUT TO A SCRIPT FILE ,OUTPUT COMMANDS ,THE save AND load COMMANDS ,IMPORTING AND
                        EXPORTING DATA.</div>
                    <div class="mt-2">5. Programming in MATAB:</div>
                    <div>RELATIONAL AND LOGICAL OPERATORS , CONDITIONAL STATEMENTS ,THE switch-case STATEMENT ,LOOPS ,NESTED LOOPS AND NESTED
                    CONDITIONAL STATEMENTS ,THE break AND continue COMMANDS ,EXAMPLES OF MATLAB APPLICATIONS.</div>
                    <div class="mt-2">6. User-Defined Functions and Function Files:</div>
                    <div>CREATING A FUNCTION FILE ,STRUCTURE OF A FUNCTION FILE , Function Definition Line , Input and Output Arguments ,
                    The H1 Line and Help Text Lines , Function Body ,LOCAL AND GLOBAL VARIABLES , SAVING A FUNCTION FILE , USING A
                    USER-DEFINED FUNCTION , EXAMPLES OF SIMPLE USER-DEFINED FUNCTIONS , COMPARISON BETWEEN SCRIPT FILES AND FUNCTION FILES,
                     ANONYMOUS AND INLINE FUNCTIONS.</div>
                    <div class="mt-2">7. Three-Dimensional Plots:</div>
                    <div>LINE PLOTS , MESH AND SURFACE PLOTS ,PLOTS WITH SPECIAL GRAPHICS ,THE view COMMAND ,EXAMPLES OF MATLAB
                     APPLICATIONS.</div>
                    <div class="mt-2">8. Polynomials, Curve Fitting, and Interpolation:</div>
                    <div>Value of a Polynomial ,Roots of a Polynomial ,Addition, Multiplication, and Division of Polynomials ,
                    Derivatives of Polynomials , CURVE FITTING , Curve Fitting with Polynomials; ,The polyfit Function , INTERPOLATION ,
                     THE BASIC FITTING INTERFACE , EXAMPLES OF MATLAB APPLICATIONS.</div>
                    <div class="mt-2">9. Applications in Numerical Analysis:</div>
                    <div>SOLVING AN EQUATION WITH ONE VARIABLE,FINDING A MINIMUM OR A MAXIMUM OF A FUNCTION ,NUMERICAL INTEGRATION
                    ,ORDINARY DIFFERENTIAL EQUATIONS ,EXAMPLES OF MATLAB APPLICATIONS.</div>
                    <div class="mt-2">10. MATLAB Simulink:</div>
                    <div>INTRODUCTION ,WORKING IN SIMULINK ,USEFULL TEMINOLOGY ,CLOSED LOOP CONTROL SYSTEM ,SUBSYTEM ,USER DEFINE FUNCTIONS ,
                    Polynomials ,Derivatives of Polynomials ,CURVE FITTING ,Curve Fitting with Polynomials; ,The polyfit Function
                    INTERPOLATION ,THE BASIC FITTING INTERFACE ,EXAMPLES OF MATLAB APPLICATIONS.</div>
                    <div class="mt-2">11. Simulink Applications:</div>
                    <div>RUNNING SIMULINK MODEL ,MODELING OF CAPACITOR SYSTEM ,MODELING OF SERIES RLC.</div>
                </div>
            )
        }else if(ch === "Fee"){
            return (
                <div>
                    <h4 class="mt-3">Fee Structure & Course Duration-</h4>
                    <div class="mt-3"><strong>• Course :-</strong> Python Basic and Advance.</div>
                    <div class="mt-3"><strong>• Level :-</strong> Master Certification.</div>
                    <div class="mt-3"><strong>• Batch :-</strong> Weekends, Weekdays.</div>
                    <div class="mt-3"><strong>• Format :-</strong> Class Room Training.</div>
                    <div class="mt-3"><strong>• Course Fee :-</strong> 25000 /-
                    </div>
                    <div class="mt-3"><strong>• Course Duration :-</strong> 3 Months.</div>
                    <div class="mt-3"><strong>• Training Location :-</strong> HazaratGanj Branch, Lucknow.</div>
                </div>
            );
        }else if(ch === "Contact"){
            return (
                <div>
                    <h4 class="mt-3">HR Counsellor-</h4>
                    <div class="mt-2"><strong>Mr. Deepak Kanuajia.</strong></div>
                    <div class="mt-2"><strong>Email :-</strong> Deepak@scimox.com.</div>
                    <div class="mt-2"><strong>Phone :-</strong> (+91) - 7011907181.</div>
                    <h4 class="mt-3">IT Trainer-</h4>
                    <div class="mt-2"><strong>Mr. Rishi Kanuajia.</strong></div>
                    <div class="mt-2"><strong>Email :-</strong> Rishi@scimox.com.</div>
                    <div class="mt-2"><strong>Phone :-</strong> (+91) - 9457384665.</div>
                </div>
            );
        }else if(ch === "Benefits"){
            return (
                <div>
                    <h4 class="mt-3">Benefits of Scimox Training Institute-</h4>
                    <div class="mt-3"><strong>1. 3 Month Advance MATLAB Course With Live Project.</strong></div>
                    <div class="mt-2"><strong>2. Syllabus is based on by Job Description.</strong></div>
                    <div class="mt-2"><strong>3. Resume Modification As Per Company Norm.</strong></div>
                    <div class="mt-2"><strong>4. Working on 10 + Live Appication.</strong></div>
                    <div class="mt-2"><strong>6. 1 Year Membership.</strong></div>
                    <div class="mt-2"><strong>7. 100% Interview Guarantee.</strong></div>
                </div>
            );
        }
    }

    render(){
        return (
             <div id="Modal_Content_Color">
                <div class="d-flex justify-content-around">
                    <div onClick={this.Overview}><p id="Bottom_Border_line"><strong>Overview</strong></p></div>
                    <div onClick={this.Module}><p id="Bottom_Border_line1"><strong>Course</strong></p></div>
                    <div onClick={this.Fee}><p id="Bottom_Border_line2"><strong>Fee</strong></p></div>
                    <div onClick={this.Contact}><p id="Bottom_Border_line3"><strong>Contact</strong></p></div>
                    <div onClick={this.Benefits}><p id="Bottom_Border_line4"><strong>Scimox</strong></p></div>
                </div>
                <div>{this.Check()}</div>
             </div>
        );
    }
}

export default Matlab;